<template>
  <div class="tender-card tender-card-skeleton">
    <v-skeleton-loader type="sentences" width="400" />
  </div>
</template>

<script>
  import { VSkeletonLoader } from 'vuetify/lib';

  export default {
    name: 'TenderCardSkeleton',
    components: { VSkeletonLoader },
  };
</script>

<style scoped lang="scss">
  .tender-card-skeleton {
    height: 76px;
    display: flex;
    align-items: center;
  }
</style>
